<template>
    <v-dialog
        :value="isOpen"
        scrollable
        max-width="700px"
        transition="slide-y-transition"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title class="d-flex justify-center">
                <h2 class="text-h5">
                    Komentarz do pozycji {{ rubber ? rubber.serialNumber : '' }}
                </h2>
            </v-card-title>

            <v-divider />

            <v-card-text class="pa-4">
                <h3 class="text-subtitle-1 font-weight-bold mb-2">
                    Dodaj komentarz do pozycji {{ rubber ? rubber.serialNumber : '' }}
                </h3>
                <v-textarea
                    v-model="newCommentText"
                    outlined
                    dense
                    rows="3"
                    counter="500"
                    maxlength="500"
                    placeholder="Wpisz komentarz..."
                    :disabled="commentSaveLoading"
                />
                <v-btn
                    color="primary"
                    small
                    :disabled="!isCommentValid || commentSaveLoading"
                    :loading="commentSaveLoading"
                    @click="addComment"
                >
                    <v-icon left small>
                        mdi-plus
                    </v-icon>
                    Dodaj
                </v-btn>

                <v-divider class="my-4" />

                <div>
                    <h3 class="text-subtitle-1 font-weight-bold mb-2">
                        Historia komentarzy
                    </h3>
                    <div v-if="commentsLoading" class="text-center py-4">
                        <v-progress-circular indeterminate color="primary" />
                    </div>
                    <div v-else-if="comments.length === 0" class="text-center py-4 grey--text">
                        Brak komentarzy
                    </div>
                    <div v-else class="comments-list">
                        <div v-for="(comment, index) in comments" :key="comment.id">
                            <div class="py-3">
                                <div class="d-flex justify-space-between align-start">
                                    <div class="flex-grow-1 comment-text-wrapper">
                                        <div class="text-body-1 black--text mb-1">
                                            {{ comment.text }}
                                        </div>
                                        <div class="text-caption grey--text">
                                            {{ formatCommentMeta(comment) }}
                                        </div>
                                    </div>
                                    <v-btn
                                        icon
                                        small
                                        color="error"
                                        :disabled="commentDeleteLoading"
                                        @click="deleteComment(comment.id)"
                                    >
                                        <v-icon small>
                                            mdi-delete
                                        </v-icon>
                                    </v-btn>
                                </div>
                            </div>
                            <v-divider v-if="index < comments.length - 1" />
                        </div>
                    </div>
                </div>
            </v-card-text>

            <v-divider />

            <v-card-actions>
                <v-btn color="error" text @click="onClose">
                    Zamknij
                </v-btn>
                <v-spacer />
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import dateFormatter from '@/mixins/dateFormatter'

export default {
    name: 'CommentsDialog',
    mixins: [dateFormatter],
    props: {
        isOpen: {
            type: Boolean
        },
        rubber: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            newCommentText: ''
        }
    },
    computed: {
        comments() {
            return this.$store.state.configurations.rubberRegistry.comments
        },
        commentsLoading() {
            return this.$store.state.configurations.rubberRegistry.commentsLoading
        },
        commentSaveLoading() {
            return this.$store.state.configurations.rubberRegistry.commentSaveLoading
        },
        commentDeleteLoading() {
            return this.$store.state.configurations.rubberRegistry.commentDeleteLoading
        },
        isCommentValid() {
            return this.newCommentText && this.newCommentText.trim().length > 0 && this.newCommentText.length <= 500
        }
    },
    watch: {
        isOpen(newVal) {
            if (newVal && this.rubber) {
                this.loadComments()
            } else if (!newVal) {
                this.clearComments()
                this.newCommentText = ''
            }
        }
    },
    methods: {
        loadComments() {
            if (this.rubber && this.rubber.id) {
                return this.$store.dispatch('configurations/getRubberComments', this.rubber.id)
            }

            return Promise.resolve()
        },
        async addComment() {
            if (!this.isCommentValid || !this.rubber) return

            try {
                const response = await this.$store.dispatch('configurations/createRubberComment', {
                    rubberId: this.rubber.id,
                    text: this.newCommentText.trim()
                })

                this.newCommentText = ''

                if (response && response.data) {
                    this.$store.commit('configurations/ADD_RUBBER_COMMENT', response.data)
                }
            } catch (error) {
                () => { }
            }
        },
        async deleteComment(commentId) {
            try {
                await this.$store.dispatch('configurations/deleteRubberComment', commentId)
                await this.loadComments()
            } catch (error) {
                () => { }
            }
        },
        clearComments() {
            this.$store.dispatch('configurations/clearRubberComments')
        },
        formatCommentMeta(comment) {
            const author = comment.createdBy ? `${comment.createdBy.firstName} ${comment.createdBy.lastName}` : 'Nieznany'
            const date = this.formatDate(comment.createdAt, true)

            return `${author}, ${date}`
        },
        onClose() {
            this.$emit('on-close')
        }
    }
}
</script>

<style scoped>
.comments-list {
    max-height: 300px;
    overflow: hidden auto;
}

.comment-text-wrapper {
    word-break: break-word;
    min-width: 0;
}
</style>
